import { render, staticRenderFns } from "./DodajDejavnosti.vue?vue&type=template&id=545295a6&"
import script from "./DodajDejavnosti.vue?vue&type=script&lang=js&"
export * from "./DodajDejavnosti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports